import { proxy, useSnapshot } from 'valtio'
import { devtools } from 'valtio/utils'

type FocusPane =
  | {
      mode: 'tray-notes' | 'tray-slides' | 'stage' | 'questions' | 'chat'
    }
  | {
      mode: 'participants'
      participantIds: number[]
    }
  | {
      mode: 'screens'
      screenIds: number[]
    }

const state = proxy({
  enabled: false,
  panes: [] as FocusPane[],
  widgets: {
    liveTimer: false,
    timer: false,
    clock: false,
    stopwatch: false,
    audienceCount: false,
    reactions: false,
  },
})

devtools(state, { name: 'focusMode' })

const enableFocusMode = () => {
  state.enabled = true
}

const startPresenterMode = () => {
  state.panes = [{ mode: 'tray-slides' }, { mode: 'tray-notes' }]
  enableFocusMode()
}

const setFocusMode = (panes: FocusPane[], widgets: typeof state.widgets) => {
  // eslint-disable-next-line prefer-destructuring
  state.panes[0] = panes[0]
  // eslint-disable-next-line prefer-destructuring
  state.panes[1] = panes[1]
  state.widgets = widgets
}

const disableFocusMode = () => {
  state.enabled = false
}

const toggleWidget = (widget: keyof (typeof state)['widgets']) => {
  state.widgets[widget] = !state.widgets[widget]
}

const useFocusMode = () => {
  return useSnapshot(state)
}

export {
  type FocusPane,
  enableFocusMode,
  startPresenterMode,
  setFocusMode,
  disableFocusMode,
  toggleWidget,
  useFocusMode,
}
